"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChartLegend = exports.formatComparisonLegendLabel = exports.formatCombinedUsageForChart = exports.createLines = exports.createBars = exports.createLine = exports.createSegments = exports.formatDescription = exports.isEmpty = exports.formatComparisonLabel = exports.formatLabel = exports.emptyBars = exports.getBarWidth = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var utils_1 = require("../../utils");
var StaggeredLabel_1 = require("./StaggeredLabel/StaggeredLabel");
var UsageChartTooltip_1 = require("./UsageChartTooltip");
var getBarWidth = function (datePeriod) {
    return datePeriod === 'daily'
        ? '0.4rem'
        : datePeriod === 'monthly'
            ? '1.2rem'
            : '2.4rem';
};
exports.getBarWidth = getBarWidth;
var emptyBars = function (n) {
    return Array.from(Array(n), function () { return ({ segments: [] }); });
};
exports.emptyBars = emptyBars;
var formatLabel = function (date, datePeriod, tooltip) {
    switch (datePeriod) {
        case 'yearly':
            return (0, date_fns_1.format)(date, 'MMM');
        case 'monthly':
            return tooltip ? (0, date_fns_1.format)(date, 'd MMM') : (0, date_fns_1.format)(date, 'd');
        case 'daily':
            return tooltip ? ((0, date_fns_1.format)(date, 'HH:mm')) : (react_1.default.createElement(StaggeredLabel_1.StaggeredLabel, { stagger: 4 }, (0, date_fns_1.format)(date, 'HH:mm')));
        default:
            return (0, date_fns_1.format)(date, 'dd/MM/yyyy');
    }
};
exports.formatLabel = formatLabel;
var formatComparisonLabel = function (date, datePeriod, comparisonType) {
    switch (comparisonType) {
        case 'previousYear':
            return (0, date_fns_1.format)(date, 'MMM yyyy');
        case 'oneMonthEarlier':
        case 'sameMonthLastYear':
            return (0, date_fns_1.format)(date, 'd MMM yyyy');
        case 'noComparison':
        default:
            return (0, exports.formatLabel)(date, datePeriod);
    }
};
exports.formatComparisonLabel = formatComparisonLabel;
var isGasEmpty = function (data, unit) {
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    return ((data.current.gas === null || data.current.gas[unitProp] === null) &&
        (!data.comparison ||
            data.comparison.gas == null ||
            data.comparison.gas[unitProp] == null));
};
var isElecEmpty = function (data, unit) {
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    return ((data.current.electricity === null ||
        data.current.electricity[unitProp] === null) &&
        (!data.comparison ||
            data.comparison.electricity == null ||
            data.comparison.electricity[unitProp] == null));
};
var isEmpty = function (data, fuel, unit) {
    switch (fuel) {
        case 'both':
            return isGasEmpty(data, unit) && isElecEmpty(data, unit);
        case 'electricity':
            return isElecEmpty(data, unit);
        case 'gas':
            return isGasEmpty(data, unit);
    }
};
exports.isEmpty = isEmpty;
var formatDescription = function (_a, fuel, unit, datePeriod, formatter) {
    var current = _a.current, comparison = _a.comparison;
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    var dateFormat = datePeriod === 'yearly'
        ? 'MM-yyyy'
        : datePeriod === 'monthly'
            ? 'dd-MM-yyyy'
            : 'HH:mm, dd-MM-yyyy';
    var description = '';
    if (current.date) {
        if ((fuel === 'electricity' || fuel === 'both') && current.electricity) {
            description += "".concat((0, date_fns_1.format)(current.date, dateFormat), " electricity: ").concat(formatter(current.electricity[unitProp]), ", ");
        }
        if ((fuel === 'gas' || fuel === 'both') && current.gas) {
            description += "".concat((0, date_fns_1.format)(current.date, dateFormat), " gas: ").concat(formatter(current.gas[unitProp]), ", ");
        }
    }
    if (comparison && comparison.date) {
        if ((fuel === 'electricity' || fuel === 'both') && comparison.electricity) {
            description += "".concat((0, date_fns_1.format)(comparison.date, dateFormat), " electricity: ").concat(formatter(comparison.electricity[unitProp]), ", ");
        }
        if ((fuel === 'gas' || fuel === 'both') && comparison.gas) {
            description += "".concat((0, date_fns_1.format)(comparison.date, dateFormat), " gas: ").concat(formatter(comparison.gas[unitProp]), ", ");
        }
    }
    return description.slice(0, -2);
};
exports.formatDescription = formatDescription;
var createSegments = function (fuel, electricity, gas, isComparison) {
    var segments = [];
    switch (fuel) {
        case 'both':
            gas !== null &&
                segments.push({
                    value: gas,
                    type: isComparison ? 'comparison' : 'gas',
                });
            electricity !== null &&
                segments.push({
                    value: electricity,
                    type: isComparison ? 'comparison' : 'electricity',
                });
            break;
        case 'electricity':
            electricity !== null &&
                segments.push({
                    value: electricity,
                    type: isComparison ? 'comparison' : 'electricity',
                });
            break;
        case 'gas':
            gas !== null &&
                segments.push({
                    value: gas,
                    type: isComparison ? 'comparison' : 'gas',
                });
            break;
    }
    return segments;
};
exports.createSegments = createSegments;
var createLine = function (fuel, electricity, gas) {
    switch (fuel) {
        case 'both':
            if (electricity !== null && gas !== null) {
                return {
                    value: electricity + gas,
                    type: 'comparison',
                };
            }
            else if (electricity !== null) {
                return {
                    value: electricity,
                    type: 'comparison',
                };
            }
            else if (gas !== null) {
                return {
                    value: gas,
                    type: 'comparison',
                };
            }
            return;
        case 'electricity':
            return electricity !== null
                ? {
                    value: electricity,
                    type: 'comparison',
                }
                : undefined;
        case 'gas':
            return gas !== null
                ? {
                    value: gas,
                    type: 'comparison',
                }
                : undefined;
    }
};
exports.createLine = createLine;
var createBars = function (data, fuel, unit) {
    if ((0, exports.isEmpty)(data, fuel, unit)) {
        return (0, exports.emptyBars)(1);
    }
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    var bars = [];
    bars.push({
        segments: (0, exports.createSegments)(fuel, data.current.electricity && data.current.electricity[unitProp], data.current.gas && data.current.gas[unitProp]),
    });
    return bars;
};
exports.createBars = createBars;
var createLines = function (data, fuel, unit) {
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    var lines = [];
    if (data.comparison) {
        var line = (0, exports.createLine)(fuel, data.comparison.electricity && data.comparison.electricity[unitProp], data.comparison.gas && data.comparison.gas[unitProp]);
        line && lines.push(line);
    }
    return lines;
};
exports.createLines = createLines;
var formatCombinedUsageForChart = function (data, fuel, unit, datePeriod, formatter, disableLinks, setDate, comparisonType) {
    return data.map(function (usageData) { return ({
        lines: (0, exports.createLines)(usageData, fuel, unit),
        bars: (0, exports.createBars)(usageData, fuel, unit),
        description: (0, exports.formatDescription)(usageData, fuel, unit, datePeriod, formatter),
        label: (0, exports.formatLabel)(usageData.date, datePeriod),
        onClick: (0, utils_1.hasDataForFuelOption)(usageData.current, fuel) && !disableLinks
            ? function () { return setDate(usageData.date, (0, utils_1.getRefinedDatePeriod)(datePeriod)); }
            : undefined,
        tooltip: (0, exports.isEmpty)(usageData, fuel, unit) ? undefined : (react_1.default.createElement(UsageChartTooltip_1.UsageChartTooltip, { data: usageData, fuel: fuel, unit: unit, datePeriod: datePeriod, formatter: formatter, comparisonType: comparisonType })),
    }); });
};
exports.formatCombinedUsageForChart = formatCombinedUsageForChart;
var getFuelName = function (fuel) {
    return fuel === 'gas' ? 'Gas' : fuel === 'electricity' ? 'Electricity' : 'Combined';
};
var formatComparisonLegendLabel = function (fuel, date, comparisonType) {
    switch (comparisonType) {
        case 'previousYear':
            return "".concat(getFuelName(fuel), " (").concat((0, date_fns_1.format)(date, 'yyyy'), ")");
        case 'oneMonthEarlier':
        case 'sameMonthLastYear':
            return "".concat(getFuelName(fuel), " (").concat((0, date_fns_1.format)(date, 'MMM yyyy'), ")");
        case 'noComparison':
        default:
            return 'Comparison';
    }
};
exports.formatComparisonLegendLabel = formatComparisonLegendLabel;
var useChartLegend = function (fuel, date, comparisonType, comparisonDate) {
    var isComparing = comparisonType !== 'noComparison';
    var colors = (0, styled_components_1.useTheme)().colors;
    var legend = [];
    if (fuel === 'electricity' || fuel === 'both') {
        legend.push({
            type: 'electricity',
            color: colors.fuelElec,
            label: isComparing
                ? (0, exports.formatComparisonLegendLabel)('electricity', date, comparisonType)
                : getFuelName('electricity'),
        });
    }
    if (fuel === 'gas' || fuel === 'both') {
        legend.push({
            type: 'gas',
            color: colors.fuelGas,
            label: isComparing
                ? (0, exports.formatComparisonLegendLabel)('gas', date, comparisonType)
                : getFuelName('gas'),
        });
    }
    if (isComparing && comparisonDate) {
        legend.push({
            type: 'comparison',
            color: colors.fuelComparison,
            label: (0, exports.formatComparisonLegendLabel)(fuel, comparisonDate, comparisonType),
        });
    }
    return legend;
};
exports.useChartLegend = useChartLegend;
